module.exports = __webpack_public_path__ + "static/media/1-2-4.fdb67b49.png";